import Header from 'components/smart/Header';
import SectionBanner from 'pages/Home/SectionBanner';
import SectionProducts from 'pages/Home/SectionProducts';
import { Formik, Form } from 'formik';
import SectionMeta from 'components/smart/SectionMeta';
import SavePageButton from 'components/smart/SavePageButton';
import { useEffect } from 'react';
import { useSnackBar } from 'components/dumb/MuiSnackBar';
import { useHomeQuery, usePageMutation } from 'hooks/useAppQuery';

const Home = () => {
  const { showSnackBar } = useSnackBar();
  const { isError, isLoading, data } = useHomeQuery();
  const {
    isLoading: isLoadingMutation,
    mutate,
    isSuccess: isSuccessMutation,
    isError: isErrorMutation,
  } = usePageMutation('home');

  useEffect(() => {
    if (isSuccessMutation) {
      showSnackBar('保存成功', 'success');
    }
    if (isErrorMutation) {
      showSnackBar('保存失敗', 'error');
    }
  }, [isSuccessMutation, isErrorMutation]);

  if (isLoading) {
    return <div style={{ textAlign: 'center' }}>loading...</div>;
  }
  if (isError) {
    return <p>Error found</p>;
  }

  return (
    <>
      <Header />
      {data && (
        <Formik
          validateOnChange={false}
          initialValues={data}
          onSubmit={(values, { setSubmitting }) => {
            mutate(values);
            setSubmitting(false);
          }}
        >
          <Form>
            <SectionMeta title="首頁" fieldPath="pageInfo" />
            <SectionBanner />
            <SectionProducts />
            <SavePageButton isLoading={isLoadingMutation} />
          </Form>
        </Formik>
      )}
    </>
  );
};

export default Home;
